const rooms = [
  {
    name: "Standard Room",
    copy: "A restful haven for the solo professional or passing couple.",
    img: "/images/room-standard.jpeg",
    alt: "Standard Room at Tse Yaa Kuku with double bed, desk, TV and fridge",
    testId: "room-standard",
  },
  {
    name: "Comfort Room",
    copy: "Added square footage and plush furnishings for an unhurried stay.",
    img: "/images/room-comfort.jpeg",
    alt: "Comfort Room at Tse Yaa Kuku with white linen and ensuite bathroom",
    testId: "room-comfort",
  },
  {
    name: "Family Room",
    copy: "Generous layout tailored for parents and children touring Namibia.",
    img: "/images/room-family.jpeg",
    alt: "Family Room at Tse Yaa Kuku with double bed and bunk beds",
    testId: "room-family",
  },
];

export const Suites = () => (
  <section
    id="suites"
    data-testid="suites-section"
    className="py-24 bg-white border-y border-[#E3DFD5] px-8"
  >
    <div className="max-w-7xl mx-auto">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="font-mono-tag text-xs tracking-widest text-[#9E7D4E] uppercase">
          Room Categories
        </span>
        <h2 className="font-editorial text-3xl sm:text-5xl text-[#1A1A18] mt-2">
          Designed for pristine calm.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {rooms.map((r) => (
          <div
            key={r.testId}
            data-testid={r.testId}
            className="p-6 bg-[#F7F6F2] rounded-2xl border border-[#E3DFD5] hover:shadow-lg transition-shadow duration-500"
          >
            <div className="aspect-[4/3] rounded-xl overflow-hidden mb-5 relative bg-[#EBE7DD]">
              <img
                src={r.img}
                alt={r.alt}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <h4 className="font-editorial text-xl text-[#1A1A18] mb-1">{r.name}</h4>
            <p className="font-grotesk text-xs text-[#55524A] mb-4">{r.copy}</p>
            <a
              href="#booking"
              data-testid={`${r.testId}-enquire-link`}
              className="font-mono-tag text-xs text-[#9E7D4E] uppercase tracking-wider font-semibold hover:underline"
            >
              Enquire Availability →
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);
